import { render, staticRenderFns } from "./Block2Creation.vue?vue&type=template&id=6df146b0&scoped=true&"
import script from "./Block2Creation.vue?vue&type=script&lang=js&"
export * from "./Block2Creation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df146b0",
  null
  
)

export default component.exports